import Request from 'utilities/Request';

export const fetchLayoutFrameStyles = (id, version) =>
  Request.get(`/api/content/${version}/pages/background/${id}`);
